import axios from 'axios'
import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
let vm = new Vue()
const service = axios.create({
baseURL: '' + process.env.VUE_APP_BASE_API + '', // url = base url + request url
timeout: 5000 
})


service.interceptors.request.use(
config => {










return config
},
error => {

console.error(error) 
return Promise.reject(error)
}
)


service.interceptors.response.use(
/**
* If you want to get http information such as headers or status
* Please return  response => response
*/

/**
* Determine the request status by custom code
* Here is just an example
* You can also judge the status by HTTP Status Code
*/
response => {
const res = response.data









if (res && res.status !== 'SUCCESS') {
vm.$vux.toast.show({
type: 'text',
position: 'middle',
text: res.msg
})
return Promise.reject(new Error(res.msg || 'Error'))
} else {
return res
}
},
error => {
console.error('http error：' + error)
this.$vux.toast.show({
message: error.message,
type: 'error',
duration: 5 * 1000
})
return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js